import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ColumnVisibilityMap, ISortState, IUserDates } from './types';

export const viewPreferencesSlice = createSlice({
  name: 'viewPreferences',
  initialState,
  reducers: {
    userDates: (state, action: PayloadAction<IUserDates>) => {
      state.dates = action.payload;
    },
    donationListSortState: (state, action: PayloadAction<ISortState | null>) => {
      state.donationListPreferences.sortState = action.payload;
    },
    donationListSearchString: (state, action: PayloadAction<string | null>) => {
      state.donationListPreferences.searchString = action.payload;
    },
    donationListColumnVisibility: (state, action: PayloadAction<ColumnVisibilityMap | null>) => {
      state.donationListPreferences.columnVisibility = action.payload;
    },
    recipientDonationListSortState: (state, action: PayloadAction<ISortState | null>) => {
      state.recipientDonationListPreferences.sortState = action.payload;
    },
    recipientDonationListSearchString: (state, action: PayloadAction<string | null>) => {
      state.recipientDonationListPreferences.searchString = action.payload;
    },
    recipientDonationListColumnVisibility: (
      state,
      action: PayloadAction<ColumnVisibilityMap | null>
    ) => {
      state.recipientDonationListPreferences.columnVisibility = action.payload;
    },
  },
});

export const {
  donationListSortState,
  donationListSearchString,
  donationListColumnVisibility,
  recipientDonationListSortState,
  recipientDonationListSearchString,
  recipientDonationListColumnVisibility,
  userDates,
} = viewPreferencesSlice.actions;

export default viewPreferencesSlice.reducer;
